<!--
 * @FileDescription: 系统消息（注释描述）
 * @Author: xy（作者）
 -->
<template>
  <a-spin :spinning="$store.state.tabLoding">
    <div class="detail">
      <div class="detail-top">
        <div class="detail-title">{{info.messageTitle}}</div>
        <div class="detail-time">{{info.modifyTime}}</div>
      </div>
      <div class="system-detail-content" v-html="info.messageInfo"></div>
    </div>
  </a-spin>
</template>
<script>
import { getfindById } from "@/utils/api";
export default {
    data(){
        return{
          isLoding:false,
          info:{}
        }
    },
    watch: {

    },
    mounted () {
      this.$store.state.tabLoding = true
      window["getParameter"] = (com,id,token) => {
        this.getParameter(com,id,token);
      };
    },
    created () {

    },
    components: {
    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        getParameter(com,id,token){
          let params = new FormData();
          params.append('companyStoreId',com)
          params.append('id',id)
          let header = {
            Authorization: 'Bearer '+token
          };
          let data = {};
          let url = '/system/app/message/findMessageById'
          getfindById(url, params, header, data).then((res) => {
            if (res.success) {
              this.info = res.result;
            }
            this.$store.state.tabLoding = false
          });
        },
    },

}
</script>
<style lang="scss">
.system-detail-content{
  line-height: 30px;
  font-size: 14px;
  padding: 20px 10px;
  div{
    text-indent: 2rem;
  }
  img{
    object-fit: cover;
  }
}
</style>
<style scoped lang="scss">
  .detail-top{
    padding: 20px 10px 10px;
    margin: 0 12px;
    border-bottom: 1px solid #AAAAAA;
    .detail-title{
      color: #333333;
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 16px;
    }
    .detail-time{
      color: #999999;
      font-size: 12px;
    }
  }
</style>
